import initCustomSelect from './customSelect';

export default class YieldingoForm {
	private readonly dom: HTMLFormElement;
	private questions: NodeListOf<HTMLDivElement>;
	private questionsInner: HTMLDivElement;
	private slider: HTMLDivElement;
	private currentStepWrapper: HTMLSpanElement;
	private prevBtn: HTMLButtonElement;
	private nextBtn: HTMLButtonElement;
	private submitBtn: HTMLButtonElement;
	private steps: NodeListOf<HTMLDivElement>;
	private currentStep: number = 1;
	private readonly stepCount: number;

	constructor(dom: HTMLFormElement) {
		this.dom = dom;

		this.questions = dom.querySelectorAll('.yieldingo-form-question-wrapper');
		this.questionsInner = dom.querySelector('.yieldingo-form-questions-inner');
		this.currentStepWrapper = dom.querySelector('.yieldingo-form-current-step');
		this.steps = dom.querySelectorAll('.yieldingo-form-question-step');
		this.prevBtn = dom.querySelector('.yieldingo-form-previous-button');
		this.nextBtn = dom.querySelector('.yieldingo-form-continue-button');
		this.submitBtn = dom.querySelector('.yieldingo-form-submit-button');
		this.slider = dom.querySelector('.yieldingo-form-slider-inner');

		this.stepCount = this.steps.length;

		this.updateSlider();
	}

	init() {
		this.prevBtn.addEventListener('click', () => {
			if (this.currentStep < 2) {
				return;
			}
			this.currentStep--;
			this.updateSlider();
			if (this.currentStep === 1) {
				this.prevBtn.style.display = 'none';
			}
			if (this.currentStep !== this.stepCount) {
				this.nextBtn.style.display = 'inline-block';
				this.submitBtn.style.display = 'none';
			}

			this.currentStepWrapper.innerText = this.currentStep.toString();
			this.questionsInner.style.translate = `-${(this.currentStep - 1) * 100 / this.stepCount}%`;
			this.dom.dispatchEvent(new CustomEvent('change-step'));
		});
		this.nextBtn.addEventListener('click', () => {
			if (this.currentStep >= this.stepCount) {
				return;
			}
			if (!this.validateStep()) {
				return;
			}
			this.currentStep++;
			this.updateSlider();
			if (this.currentStep > 1) {
				this.prevBtn.style.display = 'inline-block';
			}
			if (this.currentStep === this.stepCount) {
				this.nextBtn.style.display = 'none';
				this.submitBtn.style.display = 'inline-block';
			}

			this.currentStepWrapper.innerText = this.currentStep.toString();
			this.questionsInner.style.translate = `-${(this.currentStep - 1) * 100 / this.stepCount}%`;
			this.dom.dispatchEvent(new CustomEvent('change-step'));
		});

		this.questions.forEach(questionWrapper => {
			const select = questionWrapper.querySelector('select');
			const triggerSelected = () => {
				questionWrapper.classList.add('filled');
				questionWrapper.classList.remove('error');
			};
			if (select.dataset.selected === '1') {
				triggerSelected();
			}
			select.addEventListener('change', triggerSelected);
		});

		initCustomSelect(this.dom);

		this.dom.addEventListener('change-step', () => {
			const anchor = this.questionsInner.parentElement.parentElement;
			console.log(anchor, window.scrollY, anchor.offsetTop);
			window.scrollBy({top: anchor.getBoundingClientRect().y - 50, behavior: 'smooth'});
		});
	}

	private validateStep(): boolean {
		let valid = true;
		const questions = this.dom.querySelectorAll<HTMLDivElement>(`.yieldingo-form-question-step[data-step="${this.currentStep}"] .yieldingo-form-question-wrapper`);
		for (const question of questions) {
			const select = question.querySelector('select');
			if (select.value === '') {
				valid = false;
				question.classList.add('error');
			}
		}
		return valid;
	}

	private updateSlider() {
		this.slider.style.width = `${100 * (this.currentStep - 1) / (this.stepCount - 1)}%`;
	}

}
